import {Routes, Route, Navigate, useLocation} from "react-router-dom";
import React, {Suspense, useEffect, useState, lazy} from "react";
import { QueryParamProvider } from 'use-query-params';
import { ReactRouter6Adapter } from 'use-query-params/adapters/react-router-6';
import LaunchPad from "./pages/LaunchPad";
import axios from "axios";
import './Login.css';
import usalcoLogo from "./images/usalco-logo-horizontal-2color-light.svg";

import Button from '@mui/material/Button';

import { DndProvider } from "react-dnd";
import { HTML5Backend } from "react-dnd-html5-backend";

import ChatContextProvider from "./ai/ChatContextProvider";
import ChatSessionProvider from "./ai/ChatSessionProvider";
import PageGuard from "./usalco_lib/PageGuard";




export const UserContext = React.createContext({});

const PING_INTERVAL = 1000*60*5;

//import Navigation from "./pages/Navigation";
const Navigation = lazy(() => import('./pages/Navigation'));

//import ExpenseReview from "./reports/ExpenseReviewReport";
const ExpenseReview = lazy(() => import('./reports/ExpenseReviewReport'));

//import DatasetReport from "./pages/DatasetReport";
const DatasetReport = lazy(() => import('./pages/DatasetReport'));

//import Report from "./pages/Report";
const Report = lazy(() => import('./pages/Report'));

//import Report2 from "./reporting/v2/Report2";
const Report2 = lazy(() => import('./reporting/v2/Report2'));

//import Report3 from "./reporting/v3/Report3";
const Report3 = lazy(() => import('./reporting/v3/Report3'));

//import DatasetSearch from "./pages/DatasetSearch";
const DatasetSearch = lazy(() => import('./pages/DatasetSearch'));

//import ReportSearch from "./pages/ReportSearch";
const ReportSearch = lazy(() => import('./pages/ReportSearch'));

//import SavedInsights from "./pages/SavedInsights";
const SavedInsights = lazy(() => import('./pages/SavedInsights'));

//import EditReport from "./pages/EditReport";
const EditReport = lazy(() => import('./pages/EditReport'));

//import ReportMetrics from "./pages/ReportMetrics";
const ReportMetrics = lazy(() => import('./pages/ReportMetrics'));

//import EditDataset from "./pages/EditDataset";
const EditDataset = lazy(() => import('./pages/EditDataset'));

//import EditNavMenu from "./pages/EditNavMenu";
const EditNavMenu = lazy(() => import('./pages/EditNavMenu'));

//import Users from "./pages/Users";
const Users = lazy(() => import('./pages/Users'));

//import UserDetail from "./pages/UserDetail";
const UserDetail = lazy(() => import('./pages/UserDetail'));

//import WhatsNewAdmin from "./pages/WhatsNewAdmin";
const WhatsNewAdmin = lazy(() => import('./pages/WhatsNewAdmin'));

//import IscFieldManagement from "./pages/IscFieldManagement";
const IscFieldManagement = lazy(() => import('./pages/IscFieldManagement'));

//import ReportViewManagement from "./pages/ReportViewManagement";
const ReportViewManagement = lazy(() => import('./pages/ReportViewManagement'));

//import AdminDataSync from "./pages/AdminDataSync";
const AdminDataSync = lazy(() => import('./pages/AdminDataSync'));
const Benchmarks = lazy(() => import('./pages/Benchmarks'));
const BenchmarkEditor = lazy(() => import('./benchmarks/BenchmarkEditor'));
const BenchmarkResults = lazy(() => import('./benchmarks/BenchmarkResults'));
const ScheduledEmails = lazy(() => import('./pages/ScheduledEmails'));
const ScheduledEmailEditor = lazy(() => import('./scheduledEmails/ScheduledEmailEditor'));
const ScheduledEmailRuns = lazy(() => import('./scheduledEmails/ScheduledEmailRuns'));
const AuditLog = lazy(() => import('./pages/AuditLog'));
const AdminSmtpTest = lazy(() => import('./pages/AdminSmtpTest'));
const SecurityManagement = lazy(() => import('./pages/SecurityManagement'));

//import SiteMap from "./pages/SiteMap";
const SiteMap = lazy(() => import('./pages/SiteMap'));

//import SiopDownload from "./reports/siop_download";
const SiopDownload = lazy(() => import('./reports/siop_download'));

//import TruckDocsUpload from "./pages/TruckDocsUpload";
const TruckDocsUpload = lazy(() => import('./pages/TruckDocsUpload'));

//import InventoryCount from "./pages/InventoryCount";
const InventoryCount = lazy(() => import('./pages/InventoryCount'));

//import InventoryCountDetails from "./pages/InventoryCountDetails";
const InventoryCountDetails = lazy(() => import('./pages/InventoryCountDetails'));

//import InventoryCountWorkflows from "./pages/InventoryCountWorkflows";
const InventoryCountWorkflows = lazy(() => import('./pages/InventoryCountWorkflows'));

//import TruckDocsUpload2 from "./pages/TruckDocsUpload2";
const TruckDocsUpload2 = lazy(() => import('./pages/TruckDocsUpload2'));

//import DataTool from "./pages/DataTool";
const DataTool = lazy(() => import('./pages/DataTool'));

//import OrderRaft from "./raft/OrderRaft";
const OrderRaft = lazy(() => import('./raft/OrderRaft'));

//import ShipToSalesHistoryRaft from "./raft/ShipToSalesHistoryRaft";
const ShipToSalesHistoryRaft = lazy(() => import('./raft/ShipToSalesHistoryRaft'));

//import ReclassReviewRaft from "./raft/ReclassReviewRaft";
const ReclassReviewRaft = lazy(() => import('./raft/ReclassReviewRaft'));

//import LogisticsGraceOrders from "./pages/LogisticsGraceOrders";
const LogisticsGraceOrders = lazy(() => import('./pages/LogisticsGraceOrders'));

//import IscReport from "./pages/IscReport";
const IscReport = lazy(() => import('./pages/IscReport'));

//import DocUpload from "./docudrop/DocUpload";
const DocUpload = lazy(() => import('./docudrop/DocUpload'));

//import DocView from "./docudrop/DocView";
const DocView = lazy(() => import('./docudrop/DocView'));

//import ArDocUpload from "./docudrop/ArDocUpload";
const ArDocUpload = lazy(() => import('./docudrop/ArDocUpload'));

//import ArDocView from "./docudrop/ArDocView";
const ArDocView = lazy(() => import('./docudrop/ArDocView'));

//import IscDataSyncfusion from "./pages/IscDataSyncfusion";
const IscDataSyncfusion = lazy(() => import('./pages/IscDataSyncfusion'));

//import IscPlanManagement from "./pages/IscPlanManagement";
const IscPlanManagement = lazy(() => import('./pages/IscPlanManagement'));

//import AqueductProjectsLanding from "./pages/Aqueduct/AqueductProjectsLanding";
const AqueductProjectsLanding = lazy(() => import('./pages/Aqueduct/AqueductProjectsLanding'));

//import AqueductProjectTemplates from "./pages/Aqueduct/AqueductProjectTemplates";
const AqueductProjectTemplates = lazy(() => import('./pages/Aqueduct/AqueductProjectTemplates'));

//import AqueductUploadDetail from "./pages/Aqueduct/AqueductUploadDetail";
const AqueductUploadDetail = lazy(() => import('./pages/Aqueduct/AqueductUploadDetail'));

//import AqueductTemplateEditor from "./pages/Aqueduct/AqueductTemplateEditor";
const AqueductTemplateEditor = lazy(() => import('./pages/Aqueduct/AqueductTemplateEditor'));

//import AqueductTemplateDetail from "./pages/Aqueduct/AqueductTemplateDetail";
const AqueductTemplateDetail = lazy(() => import('./pages/Aqueduct/AqueductTemplateDetail'));

const AqueductBundledTemplateEditor = lazy(() => import('./pages/Aqueduct/AqueductBundledTemplateEditor'));
const AqueductBundledTemplateDetail = lazy(() => import('./pages/Aqueduct/AqueductBundledTemplateDetail'));
const AqueductBundledTemplateUploadDetail = lazy(() => import('./pages/Aqueduct/AqueductBundledTemplateUploadDetail'));

//import MesDashboard from "./pages/mes/MesDashboard";
const MesDashboard = lazy(() => import('./pages/mes/MesDashboard'));


//import ShipAmendDashboard from "./pages/ship_amend/ShipAmendDashboard";
const ShipAmendDashboard = lazy(() => import('./pages/ship_amend/ShipAmendDashboard'));

//import ShipAmendDetail from "./pages/ship_amend/ShipAmendDetail";
const ShipAmendDetail = lazy(() => import('./pages/ship_amend/ShipAmendDetail'));

//import TelemetryOrder from "./pages/sales/TelemetryOrder";
const TelemetryOrder = lazy(() => import('./pages/sales/TelemetryOrder'));

//import Report4 from "./reporting/v4/Report4";
const Report4 = lazy(() => import('./reporting/v4/Report4'));

//import ReportBuilder from "./reporting/v4/builder/ReportBuilder";
const ReportBuilder = lazy(() => import('./reporting/v4/builder/ReportBuilder'));

export default function App() {
    const [loading, setLoading] = useState(true);
    const [authCallComplete, setAuthCallComplete] = useState(false);
    const [authorized, setAuthorized] = useState(false);
    const [authURL, setAuthURL] = useState('');
    const [user, setUser] = useState({});
    const location = useLocation();

    useEffect(() => {
            if(!authCallComplete)
                return;

            axios.post(window.config.API_URL+'log/add', {
                type: 'Page View',
                data: JSON.stringify({
                    url: location.pathname,
                    windowWidth: window.innerWidth,
                    windowHeight: window.innerHeight,
                    userAgent: window.navigator.userAgent,
                    touchScreen: (('ontouchstart' in window) ||
                        (navigator.maxTouchPoints > 0) ||
                        (navigator.msMaxTouchPoints > 0))
                })
            }, {withCredentials: true});
        }, [location, authCallComplete]
    );

    const auth = (ping) => {
        if(ping===false)
            setLoading(true);
        axios.post(window.config.API_URL+'user_authorization', {}, { withCredentials: true })
            .then(response => {
                setLoading(false);
                if(response.data.status==='redirect') {
                    setAuthURL(response.data.url);
                    setAuthorized(false);
                }
                if(response.data.status==='success' && ping===false) {
                    response.data.data.navigation = JSON.parse(response.data.data.navigation);
                    setUser(response.data.data);
                    setAuthorized(true);
                }
                setAuthCallComplete(true);
            })
            .catch(error => {
                console.log(error);
                setLoading(false);
            });
    };

    useEffect(() => {
        auth(false);


        // Define the function to ping the server
        const pingServer = async () => {
            try {
                auth(true);
            } catch (error) {
                console.error('Failed to ping server:', error);
                // Optional: Handle errors, e.g., by logging the user out if the session is truly lost
            }
        };

        // Set up the interval
        const intervalId = setInterval(pingServer, PING_INTERVAL);

        // This is the cleanup function that React will run when the component unmounts
        return () => {
            clearInterval(intervalId); // Clear the interval to prevent memory leaks
        };
    }, []);

    const signIn = () =>{
        window.open(authURL, "_self");
    };

    const defaultLoginCopy = {
        productName: 'The Reservoir',
        eyebrow: 'Welcome',
        title: 'All your operational insight, in one place.',
        lede: 'Sign in to explore live dashboards, plant performance, and the reporting tools you rely on every day. We will route you through secure sign-on and return you here.',
        ctaLabel: 'Sign in with Microsoft',
        highlights: [
            'Operational dashboards tuned for plant teams and daily decision-making.',
            'Reporting that keeps filters, views, and exports close at hand.',
            'Quickly pick up where you left off with recent work and shared views.'
        ],
        help: 'We will never ask for your password inside The Reservoir itself.',
        sideTitle: 'New to The Reservoir?',
        sideIntro: 'We can get you set up with the right access and dashboards for your role.',
        sideItems: [
            {
                title: 'Built for daily operations',
                body: 'From KPIs to reporting, everything stays close to the workflows that keep plants moving.'
            },
            {
                title: 'Need help fast?',
                body: 'Reach out to your plant admin or the IT service desk for quick access updates.'
            }
        ]
    };
    const loginCopy = window.config?.LOGIN_COPY || defaultLoginCopy;
    const loginHighlights = Array.isArray(loginCopy.highlights) ? loginCopy.highlights : defaultLoginCopy.highlights;
    const loginSideItems = Array.isArray(loginCopy.sideItems) ? loginCopy.sideItems : defaultLoginCopy.sideItems;

    return (
        <div className={`App${authorized ? '' : ' App--login'}`}>
            {
                loading ?
                    <div className='app-loading'>
                        <div className='app-loading__card'>
                            <div className='app-loading__spinner' aria-hidden='true'></div>
                            <p className='app-loading__eyebrow'>Just a moment</p>
                            <p className='app-loading__title'>Filling up The Reservoir.</p>
                            <p className='app-loading__subtitle'>We are loading your workspace.</p>
                        </div>
                    </div>
                    :
                    !authorized ?
                        <div className='loginShell'>
                            <header className='login__brand'>
                                <img className='login__logo' src={usalcoLogo} alt='Usalco' />
                                <span className='login__product'>{loginCopy.productName || defaultLoginCopy.productName}</span>
                            </header>
                            <section className='login'>
                                <div className='login__card'>
                                    <p className='eyebrow'>{loginCopy.eyebrow || defaultLoginCopy.eyebrow}</p>
                                    <h1>{loginCopy.title || defaultLoginCopy.title}</h1>
                                    <p className='login__lede'>
                                        {loginCopy.lede || defaultLoginCopy.lede}
                                    </p>
                                    <div className='login__form'>
                                        <Button onClick={signIn} variant='contained'>
                                            {loginCopy.ctaLabel || defaultLoginCopy.ctaLabel}
                                        </Button>
                                    </div>
                                    <div className='login__highlights'>
                                        {loginHighlights.map((highlight) => (
                                            <div key={highlight} className='login-highlight'>
                                                <span className='login-highlight__marker'>•</span>
                                                <span>{highlight}</span>
                                            </div>
                                        ))}
                                    </div>
                                    <p className='login__help'>{loginCopy.help || defaultLoginCopy.help}</p>
                                </div>
                                <div className='login__side'>
                                    <div className='side-card'>
                                        <h2>{loginCopy.sideTitle || defaultLoginCopy.sideTitle}</h2>
                                        <p>{loginCopy.sideIntro || defaultLoginCopy.sideIntro}</p>
                                    </div>
                                    <div className='side-list'>
                                        {loginSideItems.map((item, index) => (
                                            <div className='side-list__item' key={`${item.title}-${index}`}>
                                                <h3>{item.title}</h3>
                                                <p>{item.body}</p>
                                            </div>
                                        ))}
                                    </div>
                                </div>
                            </section>
                        </div> :
                        <UserContext.Provider value={user}>
                            <ChatContextProvider>
                            <ChatSessionProvider>
                            <QueryParamProvider adapter={ReactRouter6Adapter}>
                                <DndProvider backend={HTML5Backend}>
                                    <Suspense fallback={
                                        <div className='app-loading app-loading--inline'>
                                            <div className='app-loading__spinner' aria-hidden='true'></div>
                                            <p className='app-loading__title'>Loading your view.</p>
                                        </div>
                                    }>
                                        <PageGuard>
                                        <Routes>
                                            <Route path="/" element={<LaunchPad />}/>

                                            <Route path="users" element={<Users />}/>
                                            <Route path="user/:user_id" element={<UserDetail />}/>
                                            <Route path="whats-new-admin" element={<WhatsNewAdmin />}/>
                                            <Route path="admin/data-sync" element={<AdminDataSync />}/>
                                            <Route path="admin/smtp-test" element={<AdminSmtpTest />}/>
                                            <Route path="benchmarks" element={<Benchmarks />}/>
                                            <Route path="benchmarks/new" element={<BenchmarkEditor />}/>
                                            <Route path="benchmarks/:guid/edit" element={<BenchmarkEditor />}/>
                                            <Route path="benchmarks/:guid/results" element={<BenchmarkResults />}/>
                                            <Route path="scheduled-emails" element={<ScheduledEmails />}/>
                                            <Route path="scheduled-emails/new" element={<ScheduledEmailEditor />}/>
                                            <Route path="scheduled-emails/:guid/edit" element={<ScheduledEmailEditor />}/>
                                            <Route path="scheduled-emails/:guid/runs" element={<ScheduledEmailRuns />}/>
                                            <Route path="audit-log" element={<AuditLog />}/>
                                            <Route path="admin/security" element={<SecurityManagement />}/>
                                            <Route path="isc/fields" element={<IscFieldManagement />}/>
                                            <Route path="management/views" element={<ReportViewManagement />}/>
                                            <Route path="site-map" element={<SiteMap />}/>
                                            <Route path="navigation/:nav_id" element={<Navigation />}/>
                                            <Route path="navigation" element={<Navigation />}/>
                                            <Route path="navigation_menu/:nav_id" element={<EditNavMenu />}/>

                                            <Route path="/datasets" element={<DatasetSearch />}/>
                                            <Route path="/insights" element={<SavedInsights />}/>
                                            <Route path="/edit_dataset/:datasetID" element={<EditDataset />}/>
                                            <Route path="/dataset/:datasetID" element={<DatasetReport />}/>
                                            <Route path="/TransportationDocs/:CompanyID/:Division/:OrderNumber" element={<TruckDocsUpload />}/>
                                            <Route path="/TransportationDocs/:CompanyID/:Division/:OrderNumber/:OrderLineNumber" element={<TruckDocsUpload />}/>
                                            <Route path="/TransportationDocs/" element={<TruckDocsUpload2 />}/>

                                            <Route path="/reports" element={<ReportSearch />}/>
                                            <Route path="/reports/metrics/:reportGuid" element={<ReportMetrics />}/>
                                            <Route path="/edit_report/:reportID" element={<EditReport />}/>
                                            <Route path="/inventory_count" element={<InventoryCount />}/>
                                            <Route path="/inventory_count_workflows" element={<InventoryCountWorkflows />}/>
                                            <Route path="/inventory_count/:countID" element={<InventoryCountDetails />}/>

                                            <Route path="/raft/79E31DDF-90D4-433B-B34F-15F2B3959276" element={<DataTool />}/>
                                            <Route path="/raft/AA19007F-297A-49CC-AF0D-9F965ACF0736" element={<OrderRaft />}/>
                                            <Route path="/raft/5A6F3E1B-6C2D-4A31-9C5D-8B3B1D8F2A4E" element={<ShipToSalesHistoryRaft />}/>
                                            <Route path="/raft/D7E2B4A1-3F8C-4D92-A1B5-6C9E0F2D8A37" element={<ReclassReviewRaft />}/>

                                            <Route path="/isc/data_entry" element={<IscDataSyncfusion />}/>
                                            <Route path="/isc/plans" element={<IscPlanManagement />}/>
                                            <Route path="/isc/reporting" element={<Navigate to="/isc/reporting/main" replace />}/>
                                            <Route path="/isc/reporting/:reportType" element={<IscReport />}/>
                                            <Route path="/misc/grace_reorder" element={<LogisticsGraceOrders />}/>

                                            <Route path="/siop_download" element={<SiopDownload />}/>
                                            <Route path="report/expense_review" element={<ExpenseReview />}/>

                                            <Route path="/report/:reportID" element={<Report />}/>
                                            <Route path="/report2/:reportID" element={<Report2 />}/>
                                            <Route path="/report3/:reportID" element={<Report3 />}/>
                                            <Route path="/report4/builder" element={<ReportBuilder />}/>
                                            <Route path="/report4/:reportID" element={<Report4 />}/>

                                            <Route path="/docs" element={<DocUpload />}/>
                                            <Route path="/sales_order_documents" element={<DocUpload />}/>
                                            <Route path="/view_sales_order_documents" element={<DocView />}/>

                                            <Route path="/docudrop/ar" element={<ArDocUpload />}/>
                                            <Route path="/docuview/ar" element={<ArDocView />}/>

                                            <Route path="/aqueduct" element={<AqueductProjectsLanding />} />
                                            <Route path="/aqueduct/project/:project_guid" element={<AqueductProjectTemplates />} />
                                            <Route path="/aqueduct/upload/:upload_id" element={<AqueductUploadDetail />} />
                                            <Route path="/aqueduct/template/new" element={<AqueductTemplateEditor />} />
                                            <Route path="/aqueduct/template/:template_guid" element={<AqueductTemplateEditor />} />
                                            <Route path="/aqueduct/template/:template_guid/view" element={<AqueductTemplateDetail />} />
                                            <Route path="/aqueduct/template/:template_guid/uploads" element={<AqueductTemplateDetail />} />
                                            <Route path="/aqueduct/bundled-template/new" element={<AqueductBundledTemplateEditor />} />
                                            <Route path="/aqueduct/bundled-template/:bundle_guid" element={<AqueductBundledTemplateEditor />} />
                                            <Route path="/aqueduct/bundled-template/:bundle_guid/uploads" element={<AqueductBundledTemplateDetail />} />
                                            <Route path="/aqueduct/bundled-template-upload/:upload_id" element={<AqueductBundledTemplateUploadDetail />} />

                                            {/* Batch FLOW */}
                                            <Route path="/flow/batch" element={<MesDashboard />} />
                                            <Route path="/mes" element={<Navigate to="/flow/batch" replace />} />

                                            {/* Confirm Delivery */}
                                            <Route path="/confirm-delivery" element={<ShipAmendDashboard />} />
                                            <Route path="/confirm-delivery/:shipNote/:orderNumber/:orderLine" element={<ShipAmendDetail />} />

                                            {/* Sales */}
                                            <Route path="/sales/telemetry" element={<TelemetryOrder />} />
                                        </Routes>
                                        </PageGuard>
                                    </Suspense>
                                </DndProvider>
                            </QueryParamProvider>
                            </ChatSessionProvider>
                            </ChatContextProvider>
                        </UserContext.Provider>
            }
        </div>
    );
}
